var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4868",
    "data-name": "Group 4868",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.955,
    height: 37.358,
    viewBox: "0 0 33.955 37.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38650",
    "data-name": "Path 38650",
    d: "M223.672,213.932c-.972-.331-1.957-.637-2.928-.91l-.558,1.989c.662.186,1.332.388,2,.6-1.1,6.756-3.975,16.387-14.791,25.593-10.817-9.208-13.691-18.84-14.791-25.6.747-.245,1.5-.473,2.242-.681l-.554-1.99c-1.057.294-2.127.629-3.181.995a1.033,1.033,0,0,0-.683,1.126,43.465,43.465,0,0,0,4.225,13.6,46.579,46.579,0,0,0,12.084,14.69,1.033,1.033,0,0,0,1.315,0,46.579,46.579,0,0,0,12.085-14.691,43.465,43.465,0,0,0,4.225-13.6A1.033,1.033,0,0,0,223.672,213.932Z",
    transform: "translate(-190.416 -206.23)",
    fill: "#00cd00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38651",
    "data-name": "Path 38651",
    d: "M223.938,192.94h7.953v3.718h-2.685a1.033,1.033,0,0,0,0,2.066h7.437a1.033,1.033,0,1,0,0-2.066h-2.685V192.94h7.953a2.585,2.585,0,0,0,2.582-2.582V177.137a2.585,2.585,0,0,0-2.582-2.582H223.938a2.585,2.585,0,0,0-2.582,2.582v13.221A2.585,2.585,0,0,0,223.938,192.94Zm-.516-15.8a.517.517,0,0,1,.516-.516H241.91a.517.517,0,0,1,.516.516v13.221a.517.517,0,0,1-.516.516H223.938a.517.517,0,0,1-.516-.516Z",
    transform: "translate(-215.947 -174.555)",
    fill: "#00cd00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38652",
    "data-name": "Path 38652",
    d: "M315.2,196.774a.516.516,0,1,0,.73-.73L312.58,192.7a.516.516,0,1,0-.73.73Z",
    transform: "translate(-290.494 -189.4)",
    fill: "#00cd00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38653",
    "data-name": "Path 38653",
    d: "M327.218,191.662a.516.516,0,0,0,.73-.73l-1.491-1.491a.517.517,0,1,0-.73.73Z",
    transform: "translate(-301.946 -186.713)",
    fill: "#00cd00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEps);
export default __webpack_public_path__ + "static/media/eps.bcb501d81c37b8b033857c107af6781c.svg";
export { ForwardRef as ReactComponent };